export const TENDER_ID = 4
export const TRAINING_ID = 5

export const provinces = [
  { id: 'CentralIsland', title: 'Central' },
  { id: 'Choiseul', title: 'Choiseul' },
  { id: 'Guadacanal', title: 'Guadalcanal' },
  { id: 'Isabel', title: 'Isabel' },
  { id: 'MakiraAndUllawa', title: 'Makira' },
  { id: 'Malaita', title: 'Malaita' },
  { id: 'RenellAndBellona', title: 'Rennell and Bellona' },
  { id: 'Temotu', title: 'Temotu' },
  { id: 'Western', title: 'Western' },
  { id: 'Honiara', title: 'Honiara'}
]

export const dailyFees = [
  { id: 'under100', title: 'Less than $100' },
  { id: 'from100to500', title: '$100 to $500' },
  { id: 'above500', title: 'Greater than $500' },
  { id: 'negotiable', title: 'Negotiable' }
]

export const averageRatings = [
  { id: 1, title: '1 star and more' },
  { id: 2, title: '2 stars and more' },
  { id: 3, title: '3 stars and more' },
  { id: 4, title: '4 stars and more' },
  { id: 5, title: '5 stars and more' },
]
